import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Enumerable from 'linq';
import { Enums } from 'src/app/_models/generatedEnums';
import { CallForPapersViewModel, PaperApprovalStatus, PaperSubmissionFilterViewModel, PaperSubmissionSort, PaperSubmissionSummaryViewModel, PaperSubmissionViewModel, PaperTypeViewModel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { AdminCallForPapersService, AdminConferenceSettingsService, CallForPapersService, OrganizationService } from 'src/app/_services/generatedServices';
import { PaperSearchService } from 'src/app/_services/paper-search.service';
import { ToasterService } from 'src/app/_services/toaster.service';
import { ConvertSubmissionModalComponent } from './convert-submission-modal.component';

@Component({
  selector: 'bxl-abstract-management-submissions',
  templateUrl: 'abstract-management-submissions.component.html',
})
export class AbstractManagementSubmissionsComponent implements OnInit, AfterViewInit {
  //  initialized = false;
  public PaperApprovalStatus = PaperApprovalStatus;
  public PaperApprovalStatusEnum = Enums.PaperApprovalStatusEnum;
  // papers: PaperSubmissionSummaryViewModel[];
  // filter: PaperSubmissionFilterViewModel;
  PaperSubmissionSort = PaperSubmissionSort;
  PaperSubmissionSortEnum = Enums.PaperSubmissionSortEnum;
  submitComplete2: Promise<{}> | undefined;

  organizationId: any;
  conferenceId: any;
  // paperTypes: PaperTypeViewModel[];
  myPapers: boolean;
  reviewMode: any;
  confId: string;
  fragment: string;
  pageLinkCount: number;
  blindReview: boolean;
  authorized: boolean;
  initialized: boolean;
  // currentPage = 0;
  // pageSize = 20;
  // resultCount = 0;
  // searching = false;
  constructor(private route: ActivatedRoute, public pss: PaperSearchService, private modalService: NgbModal, private adminCFP: AdminCallForPapersService, private toaster: ToasterService, private orgService: OrganizationService, private cfp: CallForPapersService, private orgAdminService: AdminConferenceSettingsService, public auth: AuthenticationService) {}

  ngOnInit(): void {
    if (window.innerWidth < 768) {
      this.pageLinkCount = 2;
    } else {
      this.pageLinkCount = 5;
    }

    this.route.fragment.subscribe((fragment) => {
      this.fragment = fragment;

      this.route.data.subscribe((routeData) => {
        this.route.paramMap.subscribe((params) => {
          this.confId = params.get('conferenceSlug');
          if (!this.confId) {
            this.confId = params.get('conferenceId');
          }
          this.myPapers = JSON.parse(routeData['myPapers']);
          this.reviewMode = JSON.parse(routeData['reviewMode']);

          console.log('Review Mode: ' + this.reviewMode);
          console.log('My Papers: ' + this.myPapers);

          this.orgService.getConferenceBySlugBasic(this.confId).subscribe((conf) => {
            this.organizationId = conf.organizationId;
            this.conferenceId = conf.id;

            this.orgAdminService.getPaperReviewersForConference(this.organizationId.toString(), this.conferenceId).subscribe((reviewers) => {
              this.authorized = Enumerable.from(reviewers).any((x) => x.id == this.auth.user.id) || !this.reviewMode;
              this.blindReview = Enumerable.from(reviewers).any((x) => x.isBlind && x.id == this.auth.user.id);

              let resetSearch = false;
              if (!fragment) {
                resetSearch = true;
              }
              this.initialized = true;

              this.pss.initialize(this.organizationId, this.conferenceId, this.myPapers, resetSearch).then((result) => {
                document.querySelector('#' + this.fragment).scrollIntoView();
              });
            });
          });
        });
      });
    });
  }

  ngAfterViewInit(): void {
    try {
    } catch (e) {}
  }

  export() {
    this.submitComplete2 = new Promise((resetButton: any, reject) => {
      this.adminCFP.exportPaperSubmissions(this.organizationId, this.conferenceId).subscribe(
        (result) => {
          const a = document.createElement('a');
          const objectUrl = URL.createObjectURL(result);
          a.href = objectUrl;
          a.download = 'Call For Papers Export.xlsx';
          a.click();
          URL.revokeObjectURL(objectUrl);
          resetButton();
        },
        (error) => {
          resetButton();
          this.toaster.messageDialog(error.error, 'Error Exporting').subscribe();
        }
      );
    });
  }

  convertMultiple() {
    var papers = this.pss.papers.filter((x) => x.checkedForMerge);
    const modalRef = this.modalService.open(ConvertSubmissionModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.organizationId = this.organizationId;
    modalRef.componentInstance.conferenceId = this.conferenceId;
    modalRef.componentInstance.paper = papers[0];
    modalRef.componentInstance.mergeWith = papers.splice(1);

    modalRef.result.then(
      (result) => {
        this.pss.papers
          .filter((x) => x.checkedForMerge)
          .forEach((paper) => {
            paper.convertedToEvent = true;
          });
      },
      (reason) => {}
    );
  }

  get multipleChecked() {
    return this.pss.papers?.filter((x) => x.checkedForMerge).length > 1;
  }

  convertToEvent(paper: PaperSubmissionSummaryViewModel) {
    const modalRef = this.modalService.open(ConvertSubmissionModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'flyout', backdropClass: 'flyout', backdrop: 'static' });
    modalRef.componentInstance.organizationId = this.organizationId;
    modalRef.componentInstance.conferenceId = this.conferenceId;
    modalRef.componentInstance.paper = paper;
    modalRef.result.then(
      (result) => {
        paper.convertedToEvent = true;
      },
      (reason) => {}
    );
  }
}
